export class OrderHighLevelModel {
    so_item: string
    display_so_item: string
    // item_category: string
    prd_code: string
    prd_name: string
}


// WEBPACK FOOTER //
// ./src/models/order/orderhighlevel.model.ts